import { createSlice } from "@reduxjs/toolkit";

const decodeJwt = (token) => {
    try {
        return JSON.parse(atob(token.split('.')[1]));
    } catch {
        return {};
    }
};

const initialState = {
    staff : null,
    idToken : null,
    accessToken : null,
    refreshToken : null,
    loan : null,
    _id : null,
    adminRole : null,
    permissions : [],
    roleSlugs : [],
}

export const staffSlice = createSlice({
    name : "staff",
    initialState,
    reducers : {
        login : (state, action) => {
            const decoded = decodeJwt(action.payload.accessToken);
            state.staff = action.payload.staff;
            state.idToken = action.payload.idToken;
            state.accessToken = action.payload.accessToken;
            state.refreshToken = action.payload.refreshToken;
            state.permissions = decoded.permissions || [];
            state.roleSlugs = decoded.roles || [];
            state.adminRole = decoded.roles?.[0] || null;
        },
        logout : (state) => {
            state.staff = null;
            state.idToken = null;
            state.accessToken = null;
            state.refreshToken = null;
            state.loan = null;
            state._id = null;
            state.adminRole = null;
            state.permissions = [];
            state.roleSlugs = [];
            sessionStorage.removeItem("persist:root");
        },
        reauthorize : (state, action) => {
            const decoded = decodeJwt(action.payload.accessToken);
            state.idToken = action.payload.idToken;
            state.accessToken = action.payload.accessToken;
            state.permissions = decoded.permissions || [];
            state.roleSlugs = decoded.roles || [];
        },
        currentLoan : (state, action) => {
            state.loan = action.payload;
        },
        isolateStaff : (state, action) => {
            state._id = action.payload
        },
        setAdminRole : (state, action) => {
            state.adminRole = action.payload
        }
    }
});

export const { login, logout, reauthorize, currentLoan, isolateStaff, setAdminRole } = staffSlice.actions;

export const selectStaff = (state) => state.staff.staff;

export const selectRole = (state) => state.staff.staff?.roles;

export const selectIDToken = (state) => state.staff.idToken;

export const selectAccessToken = (state) => state.staff.accessToken;

export const selectRefreshToken = (state) => state.staff.refreshToken;

export const selectLoan = (state) => state.staff.loan;

export const selectStaffId = (state) => state.staff._id;

export const selectAdminRole = (state) => state.staff.adminRole;

export const selectPermissions = (state) => state.staff.permissions;

export const selectRoleSlugs = (state) => state.staff.roleSlugs;

export default staffSlice.reducer;